import { IsDefined, IsDate } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';

export class TourItineraryDateDataService extends DataService<typeof Model.Products.Logic.ViewModels.TourItineraryDateItem, Model.Products.Logic.ViewModels.TourItineraryDateItem, TourItineraryDateItem> {
	static make(context?: ContextService): TourItineraryDateDataService {
		return new TourItineraryDateDataService(context, ctx => ctx.TourItineraryDates);
	}

	private static id = -1;

	add(itinerary: TourItineraryItem, defaultLanguageCode: string = 'en'): Promise<TourItineraryDateItem> {
		const entity = new Model.Products.Logic.ViewModels.TourItineraryDateItem();
		entity.id = TourItineraryDateDataService.id--;
		entity.tourItinerary = itinerary.entity;
		if (itinerary.id > 0) {
			entity.tourItineraryId = itinerary.id;
		}

		(entity as any).dynamicProperties = {
			displayName: {
				[defaultLanguageCode]: ''
			},
			ageBands: <AgeBandItem[]>[],
			paxConfig: <ItineraryDatePaxConfig>{
				min: 6,
				max: 12,
				defaultPaxPerBooking: 2,
				maxPaxPerBooking: 2,
				occupancies: []
			},
			marketsPrice: <ItineraryDateMarketPrice[]>[{
				marketId: 0,								// default Market
				roundPolicyType: 0,
				roundPolicyValue: 50,
				products: []
			}]
		};

		return this.create(() => entity);
	}

	protected map(entity: Model.Products.Logic.ViewModels.TourItineraryDateItem): TourItineraryDateItem {
		return new TourItineraryDateItemModel(entity);
	}
}

export class TourItineraryDateItemModel extends EntityModel<Model.Products.Logic.ViewModels.TourItineraryDateItem, TourItineraryDateItem> implements TourItineraryDateItem {
	@property<TourItineraryDateItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<TourItineraryDateItemModel>(o => o.entity.tourItineraryId, (o, value) => o.entity.tourItineraryId = value)
	public tourItineraryId: number;

	@property<TourItineraryDateItemModel>(o => o.entity.tourItinerary, (o, value) => o.entity.tourItinerary = value)
	public tourItinerary: TourItineraryItem;

	@property<TourItineraryDateItemModel>(o => o.entity.dateFrom, (o, value) => o.entity.dateFrom = value)
	@IsDefined()
	@IsDate()
	public dateFrom: Date;

	@property<TourItineraryDateItemModel>(o => o.entity.isPublished, (o, value) => o.entity.isPublished = value)
	public isPublished: boolean;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: { [prop: string]: any; };
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/tour-itinerary-date.data.ts